<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="css">
@import './assets/scss/base.css';
</style>



// WEBPACK FOOTER //
// src/App.vue